import { Col, Row } from "antd";
import React, { useEffect } from "react";
import InputSearchBox from "../../components/common/Input/InputSearchBox";
import SelectValue from "../../components/common/Selector/SelectValue";
import {
  valueSelectLicense,
  valueSelectStatusUser,
} from "../../utils/ValueSelect";
import "../../assets/style/pageStyle/accountManager.scss";
import "../../assets/style/index.scss";
import BaseButton from "../../components/common/Button/BaseButton";
import TableAccount from "../../components/common/Table/TableAccount";
import { useDispatch, useSelector } from "react-redux";
import {
  createAccount,
  editAccount,
  resetState,
  setLicenseUser,
  setOpenModalGetLogAcc,
  setOpenPUAddAcc,
  setSearchText,
  setStatusUser,
} from "../../services/slice/AccountSlice";
import { accountSelector } from "../../services/selector/index.";
import { IconPlus } from "../../assets/icon";
import TranslateText from "../../components/common/TranslateText";
import NoSearchResults from "../../components/common/NoSearchResults";
import ModalAddUser from "../../components/common/Modal/add/ModalAddUser";
import ModalEditUser from "../../components/common/Modal/edit/ModalEditUser";
import ModalGetLog from "../../components/common/Modal/getLog/ModalGetLog";
const CreateAcount = () => {
  const stateAcc = useSelector(accountSelector);
  const dispatch = useDispatch();

  const handleSaveAccount = (value) => {
    dispatch(createAccount(value));
  };
  const handleEditAccount = (value) => {
    dispatch(editAccount(value));
  };
  useEffect(() => {
    return () => dispatch(resetState());
  }, []);

  return (
    <div className="wrapperAccountManager containerContentPage">
      {stateAcc.isOpenModalAdd && (
        <ModalAddUser handleSave={handleSaveAccount} />
      )}
      {stateAcc.isOpenModalEdit && (
        <ModalEditUser handleEdit={handleEditAccount} />
      )}
      {/* <ModalEditUser handleEdit={handleEditAccount} /> */}
      {stateAcc.isOpenModalLog && (
        <ModalGetLog
          data={stateAcc.dataLog}
          open={stateAcc.isOpenModalLog}
          setOpen={setOpenModalGetLogAcc}
        />
      )}

      <Row className="headerPage">
        <h2 className="title">
          <TranslateText text={"Quản lý tài khoản"} />
        </h2>
      </Row>
      <Row style={{ width: "100%" }}>
        <Col className="mr-5">
          <InputSearchBox
            width={435}
            placeholder={"Tìm kiếm"}
            setText={(value) => dispatch(setSearchText(value))}
          />
        </Col>
        <Col className="mr-5">
          <SelectValue
            type={"selectGray"}
            defaultValue={"Trạng thái"}
            width={130}
            handleChange={(value) => {
              dispatch(setStatusUser(value));
            }}
            optionsValue={valueSelectStatusUser}
          />
        </Col>
        <Col>
          <SelectValue
            width={220}
            type={"selectGray"}
            defaultValue={"Quyền"}
            handleChange={(value) => dispatch(setLicenseUser(value))}
            optionsValue={[
              { value: 0, label: "Tất cả" },
              ...valueSelectLicense,
            ]}
          />
        </Col>
        <Col style={{ flexGrow: 1, display: "flex", justifyContent: "end" }}>
          <BaseButton
            handleClick={() => dispatch(setOpenPUAddAcc(true))}
            width={120}
            typeBtn={"btnOrange"}
            icon={
              <IconPlus
                width={16}
                height={14}
                style={{ marginRight: "0.5rem" }}
              />
            }
            content={`Thêm mới`}
          />
        </Col>
      </Row>
      <Row className="tableContent">
        {stateAcc.config.search && !stateAcc.data.length ? (
          <NoSearchResults />
        ) : (
          <TableAccount />
        )}
      </Row>
    </div>
  );
};
export default CreateAcount;
